export const PINNED_Z_INDEX = {
    header: 399,
    actionRow: 299,
    body: 250,
    actionColumn: 100,
}

export function pinnedCellSx(zIndex, theme, sx) {
    return {
        position: "sticky",
        left: 0,
        zIndex,
        boxShadow: `-1px 0px 0px 0px ${theme.palette.divider} inset`,
        ...sx,
    }
}
